import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import LoadingEllipsis from '@/common/LoadingEllipsis';
import TransitChargeState from '~/constants/TransitChargeState';
import { useIsMobile } from '~/context/common/DeviceContext';
import ModalContext from '~/context/vdp/ModalContext';
import { useGetStarted } from '~/hooks/vdp/cta';
import {
  getDeliveryPickup,
  getPickupInfo,
  getTransitChargeInfo,
  getVehicleStockNumber
} from '~/selectors';
import {
  GetStartedArrow,
  HeaderWrapper,
  LinkTextUnderline,
  LinkTextUppercase,
  LinkWrapper,
  Text,
  VendingIcon
} from './LiteTextBoxes.styles';
import { formatAsSoonAsDate } from './utils';

function PickupText() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const pickup = useSelector(getPickupInfo);
  const transitCharge = useSelector(getTransitChargeInfo);
  const isMobile = useIsMobile();

  if (!pickup) return null;

  const sentenceStart =
    transitCharge.state === TransitChargeState.NoCharge
      ? 'Free pickup'
      : 'Pickup';
  const asSoonAsDate = formatAsSoonAsDate(
    pickup.utcSoonestDateTimeIso,
    pickup.localTimeZone,
    isMobile ? 'short' : 'long'
  );
  const date = asSoonAsDate ? (
    <>
      <span className="font-normal">location by </span>
      {asSoonAsDate}
    </>
  ) : (
    ''
  );

  return (
    <>
      {sentenceStart}{' '}
      <span className="font-normal">
        from our{' '}
        <Clickable
          data-analytics-id="Pickup Banner - Geolocation"
          element={LinkTextUnderline}
          onClick={() => setGeolocationModalOpen(true)}
        >
          {pickup.locationCity}, {pickup.locationState}
        </Clickable>
      </span>{' '}
      {date}
    </>
  );
}

function PickupBanner() {
  const { isLoaded } = useSelector(getDeliveryPickup);
  const pickup = useSelector(getPickupInfo);
  const isMobile = useIsMobile();
  const transitCharge = useSelector(getTransitChargeInfo);
  const stockNumber = useSelector(getVehicleStockNumber);
  const handleGetStarted = useGetStarted(stockNumber);

  return isLoaded && !pickup ? null : (
    <HeaderWrapper>
      <VendingIcon />
      {!isLoaded || transitCharge.isLoading ? (
        <LoadingEllipsis />
      ) : (
        <Text>
          <PickupText />
        </Text>
      )}
      <Clickable
        data-analytics-id="Pickup Banner - Get Started"
        element={LinkWrapper}
        onClick={handleGetStarted}
      >
        {isMobile ? (
          <GetStartedArrow />
        ) : (
          <LinkTextUppercase>Get Started</LinkTextUppercase>
        )}
      </Clickable>
    </HeaderWrapper>
  );
}

export default PickupBanner;
